/**
 * Enforces Theme Settings → Cart → Minimum spend amount.
 * Below-minimum checkout uses type="button" + .cart-checkout--blocked (not a submit control).
 */
(function () {
  const minSpendCents = Number(window.theme?.settings?.minSpendCents) || 0;
  if (minSpendCents <= 0) return;

  const message =
    window.theme?.strings?.cartMinSpend ||
    'Please spend the minimum order amount before checking out.';

  function readTotalCents(fromEl) {
    const el =
      fromEl?.closest?.('[data-cart-total-cents]') ||
      fromEl ||
      document.querySelector('[data-cart-total-cents]');
    if (!el) return null;
    const n = Number(el.getAttribute('data-cart-total-cents'));
    return Number.isNaN(n) ? null : n;
  }

  function isBelowMinimum(el) {
    const total = readTotalCents(el);
    if (total == null) return el?.classList?.contains('cart-checkout--blocked');
    return total < minSpendCents;
  }

  function block(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    window.alert(message); // eslint-disable-line no-alert
  }

  document.addEventListener(
    'click',
    (evt) => {
      const btn = evt.target.closest('.js-cart-checkout, .cart-checkout--blocked');
      if (!btn) return;
      if (btn.classList.contains('cart-checkout--blocked') || isBelowMinimum(btn)) {
        block(evt);
      }
    },
    true
  );

  document.addEventListener(
    'submit',
    (evt) => {
      const form = evt.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (form.id !== 'cart' && form.id !== 'cart-drawer-form') return;
      if (isBelowMinimum(form)) block(evt);
    },
    true
  );
})();
